<template>
	<v-app>
		<v-container class="container-sec" :class="backgroundClass">
			<v-row style="justify-content: center;" class="mt-2">
				<v-col cols="12" class="register-wrapper" :class="loginWrapperBackgroundClass">
					<p class="text-center">Register</p>
					<v-form
						ref="form"
						v-model="validFormLogin"
					>
						<v-select
							v-model="distCode"
							:items="distributorCodeList"
							item-text="distributorCode"
							item-value="distributorCode"
							label="Tipe Distributor"
							outlined
							required
							hide-details="auto"
							@change="handleUserType"
							style="background-color: white; border-radius: 10px;"
						></v-select>
						<v-select
							v-model="tipeUsaha"
							item-text="businessTypeName"
							item-value="businessTypeId"
							:items="tipeUsahaList"
							:rules="[v => !!v || 'Tipe Usaha harus di isi']"
							label="Tipe Usaha"
							required
							hide-details="auto"
							dense
							outlined
							style="background-color: white;"
						></v-select>
						<v-select
							v-model="kelCabang"
							item-text="groupOutletName"
							item-value="groupOutletId"
							:items="kelCabangList"
							:rules="[v => !!v || 'Kel. Cabang harus di isi']"
							label="Kel. Cabang"
							required
							hide-details="auto"
							dense
							outlined
							style="background-color: white;"
						></v-select>
						<v-text-field
							v-model="namaPelanggan"
							:counter="64"
							:rules="[v => !!v || 'Nama Pelanggan harus di isi']"
							label="Nama Pelanggan"
							required
							dense
							outlined
							style="background-color: white;"
							hide-details="auto"
							maxlength="64"
						></v-text-field>
						<v-text-field
							v-model="password"
							:counter="100"
							:rules="[v => !!v || 'Password harus di isi']"
							label="Password anda"
							:append-icon="value ? 'mdi-eye-off' : 'mdi-eye'"
							@click:append="() => (value = !value)"
							:type="value ? 'password' : 'text'"
							required
							dense
							outlined
							style="background-color: white;"
							hide-details="auto"
							maxlength="100"
						></v-text-field>
						<v-text-field
							v-model="alamat"
							:counter="128"
							:rules="[v => !!v || 'Alamat harus di isi']"
							label="Alamat"
							required
							dense
							outlined
							style="background-color: white;"
							hide-details="auto"
							maxlength="128"
						></v-text-field>
						<v-select
							v-model="provinsi"
							item-text="provinceName"
							item-value="provinceId"
							:items="provinsiList"
							:rules="[v => !!v || 'Provinsi harus di isi']"
							label="Provinsi"
							required
							hide-details="auto"
							dense
							outlined
							style="background-color: white;"
						></v-select>
						<v-text-field
							v-model="kodePos"
							:counter="8"
							:rules="[v => !!v || 'Kode Pos harus di isi']"
							label="Kode Pos"
							required
							dense
							outlined
							style="background-color: white;"
							hide-details="auto"
							maxlength="8"
						></v-text-field>
						<v-text-field
							v-model="namaKontak"
							:counter="64"
							:rules="[v => !!v || 'Nama Kontak harus di isi']"
							label="Nama Kontak"
							required
							dense
							outlined
							style="background-color: white;"
							hide-details="auto"
							maxlength="64"
						></v-text-field>
						<v-text-field
							v-model="nomorTelp"
							:counter="64"
							:rules="[v => !!v || 'No. Telp harus di isi']"
							label="No. Telp"
							required
							dense
							outlined
							style="background-color: white;"
							hide-details="auto"
							maxlength="64"
						></v-text-field>
						<v-text-field
							v-model="email"
							:counter="64"
							:rules="[v => !!v || 'E-mail harus di isi',
        v => /.+@.+\..+/.test(v) || 'E-mail harus valid',]"
							label="Email"
							required
							dense
							outlined
							style="background-color: white;"
							hide-details="auto"
							maxlength="64"
						></v-text-field>
						<v-btn
							color="primary"
							class="mr-4"
							@click="validate"
						>
							Simpan
						</v-btn>
						<v-btn
							color="info"
							class="mr-4"
							@click="reset"
						>
							Reset Form
						</v-btn>
						<v-btn
							@click="$router.back()"
						>
							Kembali
						</v-btn>
					</v-form>
				</v-col>
			</v-row>
			<v-dialog
				v-model="dialogSuccess"
				persistent
				max-width="320"
			>
				<v-card>
					<v-card-title class="text-h5">
						Akun berhasil di daftarkan
					</v-card-title>
					<v-card-text>silahkan cek email untuk info lebih lanjut.</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="grey darken-1"
							text
							@click="dialogSuccess = false; $refs.form.reset();"
						>
							Tutup
						</v-btn>
						<v-btn
							color="pink darken-1"
							text
							@click="$router.push({name: 'login'})"
						>
							Halaman Login
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-snackbar v-model="showSnackbar" :color="snackbarColor">
				{{ snackbarMsg }}
				<template v-slot:action="{ attrs }">
					<v-btn text small v-bind="attrs" @click="showSnackbar = false">
						X
					</v-btn>
				</template>
			</v-snackbar>
			<v-overlay :absolute="absolute" :value="isLoading">
				<v-progress-circular indeterminate color="primary"> </v-progress-circular>
			</v-overlay>
		</v-container>
	</v-app>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
	data(){
		return{
			value: String,
			absolute: true,
			validFormLogin: true,
			backgroundClass: '',
			loginWrapperBackgroundClass: '',
			tipeUsaha: null,
			tipeUsahaList: [
				{value:'Kedai', name:"Kedai"},
				{value:'Warung', name:'Warung'}
			],
			kelCabang: null,
			kelCabangList: [],
			provinsi: null,
			namaPelanggan: null,
			provinsiList: [],
			email: null,
			nomorTelp: null,
			kodePos: null,
			namaKontak: null,
			alamat: null,
			password: null,
			fieldRules: [(v) => !!v || "Field harus diisi"],
			dialogSuccess: false,
			distributorCodeList: [],
			distCode: null,
		}
	},
	methods: {
		...mapActions(["getDistributor","getTipeUsaha", "getKelompokCabang", "getUserType", 'getDistributor', 'getProvinsiList','register']),
		handleUserType: function(val) {
      this.$store.commit("setDistType", 
        val
      );
    },
		getListDistributor(){
      this.getDistributor({distributorCode: ''})
      .then((response) => {
        if (response.data.status == 1) {
          this.distributorCodeList = response.data.data;
          
        }
      })
    },
		validate(){
			if (this.$refs.form.validate()) {
				this.insertData();
			}
		},
		reset(){
			this.$refs.form.reset();
		},

		loadProvinsi(){
			this.getProvinsiList().then((response) => {
				this.provinsiList = response.data.data;
			})
		},
		loadTipeUsaha(){
			this.getTipeUsaha().then((response) => {
				this.tipeUsahaList = response.data.data
			})
		},
		loadKelompokCabang(){
			this.getKelompokCabang().then((response) => {
				this.kelCabangList = response.data.data;
			})
		},
		insertData(){
			this.register({
				alamat: this.alamat,
				email: this.email,
				businessTypeId: this.kelCabang,
				kodePos: this.kodePos,
				namaKontak: this.namaKontak,
				namaPelanggan: this.namaPelanggan,
				noTelp: this.nomorTelp,
				provinceId: this.provinsi,
				groupOutletId: this.tipeUsaha,
				password: this.password,
			}).then((response) => {
				if (response.data.status == 1) {
					this.dialogSuccess = true;
				}
			})
		}
	},
	created() {
    this.$store.commit("setDistType", 
        'SMG'
      );
    if (this.distType == this.$constant.DIST_SMA) {
      this.$vuetify.theme.themes.light.primary = '#FAAC1B'; // kuning
      this.backgroundClass = 'bg-yellow-sma-andalan'; // jika username A
      this.loginWrapperBackgroundClass = 'bg-login-wrapper-sma';
    }else{
      this.backgroundClass = 'bg-pink-smg-sdn'
      this.loginWrapperBackgroundClass = 'bg-login-wrapper-smg-sdn';
    }

		this.loadProvinsi();
		this.loadTipeUsaha();
		this.loadKelompokCabang();
		this.getListDistributor();
  },
	computed:{
		...mapState(["isLoading", "userTypeListWeb", 'distTypeList','distType']),
		showSnackbar: {
      get: function() {
        return this.$store.getters.showSnackbar;
      },
      set: function() {
        this.$store.commit("hideSnackBar");
      },
    },
    snackbarMsg: {
      get: function() {
        return this.$store.getters.snackbarMsg;
      },
      set: function() {
        this.$store.commit("resetSnackBarMsg");
      },
    },
    snackbarColor: {
      get: function() {
        return this.$store.getters.snackbarColor;
      },
      set: function() {
        this.$store.commit("resetSnackBarColor");
      },
    },
	}
}
</script>


<style scoped src="./Register.scss" lang="scss" />